export default class StringHelper {
	constructor() {
		throw 'Não é possível instanciar StringHelper'
	}

	static limpaFormato(dadoFormatado, ehRG=false) {
		if (ehRG && dadoFormatado) {
			let dadoLimpo = dadoFormatado.replace(/[^0-9a-zA-Z]+/g, '')
			return dadoLimpo
		}
		if (dadoFormatado) {
			let dadoLimpo = dadoFormatado.replace(/[^\d]+/g, '')
			return dadoLimpo
		}
		return null
	}

	static limpaFormatoMonetario(dadoFormatado) {
		if (dadoFormatado) {
			let dadoString = dadoFormatado.toString()
			let dadoSemPonto = dadoString.replace(/\.+/g, '')
			let dadoSemVirgula = dadoSemPonto.replace(/,+/g, '.')
			let dadoLimpo = parseFloat(dadoSemVirgula)
			return dadoLimpo
		}
		return null
	}

	static paraCaixaAlta(frase) {
		if (frase) {
			return frase.toUpperCase()
		}
		return ''
	}

	static toUpperCaseInJson(objeto, excecao=[]) {
		const maiusculo = obj => {
			for (var prop in obj) {
				if (typeof obj[prop] === 'string' && !excecao.includes(prop)) {
					obj[prop] = obj[prop].toUpperCase()
				}
				if (typeof obj[prop] === 'object') {
					maiusculo(obj[prop])
				}
			}
			return obj
		}
		return maiusculo(objeto)
	}

	static verificaCaracterEspecial(palavra) {
		const pattern = new RegExp(/[^A-Za-z0-9\-_ªº°.,@() ]/g)
		return palavra ? pattern.test(palavra) : false
	}

	static limpaCaracterEspecial(palavra) {
		let result = ''
		result = palavra.replace(/[àáâã]/g, 'a')
		result = result.replace(/[ÀÁÂÃ]/g, 'A')
		result = result.replace(/[èéêẽ]/g, 'e')
		result = result.replace(/[ÈÉÊẼ]/g, 'E')
		result = result.replace(/[ìíîĩ]/g, 'i')
		result = result.replace(/[ÌÍÎĨ]/g, 'I')
		result = result.replace(/[òóôõ]/g, 'o')
		result = result.replace(/[ÒÓÔÕ]/g, 'O')
		result = result.replace(/[ùúûũ]/g, 'u')
		result = result.replace(/[ÙÚÛŨ]/g, 'U')
		result = result.replace(/ç/g, 'c')
		result = result.replace(/Ç/g, 'C')
		result = result.replace(/[^A-Za-z0-9\-_ªº°.,@() ]/g, '')

		return result
	}
}


// WEBPACK FOOTER //
// ./src/helpers/StringHelper.js